import React from "react";
import { Link } from "react-router-dom";

// Footer component: provides brand copyright + quick access legal/navigation links.
// Layout adapts responsively: stacked on mobile and inline on wider screens.
const Footer = () => {

  // Compute current year dynamically to avoid manual yearly edits.
  const currentYear = new Date().getFullYear();

  // Centralized link configuration so modifications are handled in one place.
  // Order also reflects priority in navigation (legal → support).
  const links = [
    { label: "Privacy", path: "/privacy" },
    { label: "Terms", path: "/terms" },
    { label: "Security", path: "/security" },
    { label: "Contact", path: "/contact" },
  ];

  return (
    <footer className="bg-[#F1F5F9] border-t border-[#E2E8F0] py-8">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between px-6 gap-4 text-[#475569] text-base font-[Manrope]">
        <div className="text-center sm:text-left">
          <p className="font-medium">
            © {currentYear} DEE­Bug™. All rights reserved.
          </p>
          <p className="text-sm mt-1">
            Created and led by{" "}
            <a
              href="https://www.sigmajahan.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium underline underline-offset-2 hover:text-[#0EA5E9] transition-colors duration-150"
            >
              Sigma Jahan
            </a>
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-8">
          {links.map(({ label, path }) => (
            <Link
              key={label}
              to={path}
              className="hover:text-[#0EA5E9] transition-colors duration-150 font-medium"
            >
              {label}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;